import { z } from 'zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';

export const typeSchema = z.enum(['website', 'renewal']);

export default createPerformableConfig(
  'tour',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
    }),
  },
  {
    name: 'Virtual Tour',
    tenant: TenantId.MPI,
    images: [],
    short: '',
  },
);
